import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import {
  Box,
  Container,
  Typography,
  Alert,
  CircularProgress,
  Paper
} from '@mui/material';
import axios from '../../utils/axiosConfig';
import BlogForm from '../../components/BlogForm';

const EditBlog = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [blog, setBlog] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchBlog();
  }, [id]);

  const fetchBlog = async () => {
    try {
      const response = await axios.get(`/api/v2/blog/${id}`);
      setBlog(response.data);
    } catch (err) {
      console.error('Error loading blog post:', err);
      if (err.response?.status === 401) {
        navigate('/admin');
      }
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (formData) => {
    try {
      const form = new FormData();
      
      // Append all form data
      Object.keys(formData).forEach((key) => {
        if (key === 'image' && formData[key] instanceof File) {
          form.append('image', formData[key]);
        } else {
          form.append(key, formData[key]);
        }
      });

      await axios.put(`/api/v2/blog/${id}`, form, {
        headers: {
          'Content-Type': 'multipart/form-data',
        }
      });
      
      navigate('/admin/dashboard');
    } catch (err) {
      console.error('Error updating blog:', err);
      setError(err.response?.data?.message || 'Failed to update blog post');
      if (err.response?.status === 401) {
        navigate('/admin');
      }
    }
  };

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Container maxWidth="md">
      <Box sx={{ mt: 4, mb: 4 }}>
        <Paper elevation={3} sx={{ p: 4 }}>
          <Typography variant="h4" component="h1" gutterBottom>
            Edit Blog Post
          </Typography>

          {error && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {error}
            </Alert>
          )}

          <BlogForm 
            initialData={blog}
            onSubmit={handleSubmit}
            loading={loading}
          />
        </Paper>
      </Box>
    </Container>
  );
};

export default EditBlog;
